import { FULL_SIZE, SQUART_SIZE } from './config'

export const getPictureImageSize = index => (index === 0 ? FULL_SIZE : SQUART_SIZE)

/**
 * To get right classname depending of total images to render 
 * @param {Number} imagesCount 
 */
export const getGridClassname = imagesCount => {
  if (imagesCount > 3) {
    return 'full-grid-gallery'
  }

  if (imagesCount > 1) {
    return 'middle-grid-gallery'
  }

  return 'simple-grid-gallery'
}

export const LEGAL_PROPERTY_LEGEND = "Recuerda que el precio final del inmueble puede variar de acuerdo a tu forma de pago y gastos notariales que se requieran, consulta los detalles con el asesor."
